// tslint:disable
/**
 * VcfgAPI
 * Vcfg API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Fitment
 */
export interface Fitment {
    /**
     * The unique Id of a vehicle entry. Do not parse the id, even if it looks like it contains information, this might change.
     * @type {string}
     * @memberof Fitment
     */
    id?: string;
    /**
     * A list of image URLs. The images show the vehicle from the outside.
     * @type {Array<string>}
     * @memberof Fitment
     */
    vehicle_images?: Array<string>;
    /**
     * The URL of an image that shows the location of the socket in a wireframe.
     * @type {string}
     * @memberof Fitment
     */
    socket_wireframe_image?: string;
    /**
     * Because we might have multiple dongles in the future, we already return information by device.
     * @type {Array<FitmentDevices>}
     * @memberof Fitment
     */
    devices?: Array<FitmentDevices>;
}
/**
 * 
 * @export
 * @interface FitmentDevices
 */
export interface FitmentDevices {
    /**
     * The model number / name of the device
     * @type {string}
     * @memberof FitmentDevices
     */
    model?: string;
    /**
     * A link to an image that shows the device installed in the socket.
     * @type {string}
     * @memberof FitmentDevices
     */
    installed_image?: string;
    /**
     * The difficulty of installing the device in the vehicle. The possible values are: 1,2,3. 1 = easy, 2 = medium, 3 = hard
     * @type {number}
     * @memberof FitmentDevices
     */
    installation_difficulty?: number;
    /**
     * A list of steps needed to install the device in the vehicle. In each step, the title, text or images is optional. But at least one of [text, image] is present.
     * @type {Array<FitmentInstallationSteps>}
     * @memberof FitmentDevices
     */
    installation_steps?: Array<FitmentInstallationSteps>;
    /**
     * Additional generic installation notes. The string is simple text with \\n for new lines.
     * @type {string}
     * @memberof FitmentDevices
     */
    installation_notes?: string;
}
/**
 * 
 * @export
 * @interface FitmentInstallationSteps
 */
export interface FitmentInstallationSteps {
    /**
     * The text instructions of the step.
     * @type {string}
     * @memberof FitmentInstallationSteps
     */
    text?: string;
    /**
     * A URL to an image that explains the step.
     * @type {string}
     * @memberof FitmentInstallationSteps
     */
    image?: string;
}

/**
 * FitmentApi - axios parameter creator
 * @export
 */
export const FitmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This endpoint returns all necessary information to display a fitment guide to a user.
         * @param {string} mapping The make/model input mapping. For now we know about aa, anwb, oeamtc.
         * @param {string} make The make of the vehicle. Example: Ford
         * @param {string} model The model of the vehicle. Example: Escort
         * @param {number} modelYear The model year of the vehicle. Example: 2016
         * @param {'lhd' | 'rhd'} steering Location of the steering. Values: [lhd,rhd]
         * @param {string} [acceptLanguage] The language the request would like the response to utilise. The default is english.
         * @param {'danlawc_dl880' | 'trakm8_connect300'} [filterDeviceType] You can optionally filter for a specific device and only return information for that device. Values: [danlawc_dl880, trakm8_connect300] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitment: async (mapping: string, make: string, model: string, modelYear: number, steering: 'lhd' | 'rhd', acceptLanguage?: string, filterDeviceType?: 'danlawc_dl880' | 'trakm8_connect300', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapping' is not null or undefined
            if (mapping === null || mapping === undefined) {
                throw new RequiredError('mapping','Required parameter mapping was null or undefined when calling getFitment.');
            }
            // verify required parameter 'make' is not null or undefined
            if (make === null || make === undefined) {
                throw new RequiredError('make','Required parameter make was null or undefined when calling getFitment.');
            }
            // verify required parameter 'model' is not null or undefined
            if (model === null || model === undefined) {
                throw new RequiredError('model','Required parameter model was null or undefined when calling getFitment.');
            }
            // verify required parameter 'modelYear' is not null or undefined
            if (modelYear === null || modelYear === undefined) {
                throw new RequiredError('modelYear','Required parameter modelYear was null or undefined when calling getFitment.');
            }
            // verify required parameter 'steering' is not null or undefined
            if (steering === null || steering === undefined) {
                throw new RequiredError('steering','Required parameter steering was null or undefined when calling getFitment.');
            }
            const localVarPath = `/fitment`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("default", ["oeamtc.external.vcfg.read"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (mapping !== undefined) {
                localVarQueryParameter['mapping'] = mapping;
            }

            if (make !== undefined) {
                localVarQueryParameter['make'] = make;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (modelYear !== undefined) {
                localVarQueryParameter['model_year'] = modelYear;
            }

            if (steering !== undefined) {
                localVarQueryParameter['steering'] = steering;
            }

            if (filterDeviceType !== undefined) {
                localVarQueryParameter['filter.device_type'] = filterDeviceType;
            }

            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FitmentApi - functional programming interface
 * @export
 */
export const FitmentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This endpoint returns all necessary information to display a fitment guide to a user.
         * @param {string} mapping The make/model input mapping. For now we know about aa, anwb, oeamtc.
         * @param {string} make The make of the vehicle. Example: Ford
         * @param {string} model The model of the vehicle. Example: Escort
         * @param {number} modelYear The model year of the vehicle. Example: 2016
         * @param {'lhd' | 'rhd'} steering Location of the steering. Values: [lhd,rhd]
         * @param {string} [acceptLanguage] The language the request would like the response to utilise. The default is english.
         * @param {'danlawc_dl880' | 'trakm8_connect300'} [filterDeviceType] You can optionally filter for a specific device and only return information for that device. Values: [danlawc_dl880, trakm8_connect300] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFitment(mapping: string, make: string, model: string, modelYear: number, steering: 'lhd' | 'rhd', acceptLanguage?: string, filterDeviceType?: 'danlawc_dl880' | 'trakm8_connect300', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fitment>> {
            const localVarAxiosArgs = await FitmentApiAxiosParamCreator(configuration).getFitment(mapping, make, model, modelYear, steering, acceptLanguage, filterDeviceType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FitmentApi - factory interface
 * @export
 */
export const FitmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary This endpoint returns all necessary information to display a fitment guide to a user.
         * @param {string} mapping The make/model input mapping. For now we know about aa, anwb, oeamtc.
         * @param {string} make The make of the vehicle. Example: Ford
         * @param {string} model The model of the vehicle. Example: Escort
         * @param {number} modelYear The model year of the vehicle. Example: 2016
         * @param {'lhd' | 'rhd'} steering Location of the steering. Values: [lhd,rhd]
         * @param {string} [acceptLanguage] The language the request would like the response to utilise. The default is english.
         * @param {'danlawc_dl880' | 'trakm8_connect300'} [filterDeviceType] You can optionally filter for a specific device and only return information for that device. Values: [danlawc_dl880, trakm8_connect300] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitment(mapping: string, make: string, model: string, modelYear: number, steering: 'lhd' | 'rhd', acceptLanguage?: string, filterDeviceType?: 'danlawc_dl880' | 'trakm8_connect300', options?: any): AxiosPromise<Fitment> {
            return FitmentApiFp(configuration).getFitment(mapping, make, model, modelYear, steering, acceptLanguage, filterDeviceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FitmentApi - object-oriented interface
 * @export
 * @class FitmentApi
 * @extends {BaseAPI}
 */
export class FitmentApi extends BaseAPI {
    /**
     * 
     * @summary This endpoint returns all necessary information to display a fitment guide to a user.
     * @param {string} mapping The make/model input mapping. For now we know about aa, anwb, oeamtc.
     * @param {string} make The make of the vehicle. Example: Ford
     * @param {string} model The model of the vehicle. Example: Escort
     * @param {number} modelYear The model year of the vehicle. Example: 2016
     * @param {'lhd' | 'rhd'} steering Location of the steering. Values: [lhd,rhd]
     * @param {string} [acceptLanguage] The language the request would like the response to utilise. The default is english.
     * @param {'danlawc_dl880' | 'trakm8_connect300'} [filterDeviceType] You can optionally filter for a specific device and only return information for that device. Values: [danlawc_dl880, trakm8_connect300] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitmentApi
     */
    public getFitment(mapping: string, make: string, model: string, modelYear: number, steering: 'lhd' | 'rhd', acceptLanguage?: string, filterDeviceType?: 'danlawc_dl880' | 'trakm8_connect300', options?: any) {
        return FitmentApiFp(this.configuration).getFitment(mapping, make, model, modelYear, steering, acceptLanguage, filterDeviceType, options).then((request) => request(this.axios, this.basePath));
    }

}


